import React from 'react'
import {
  DefaultValues,
  Resolver,
  useForm,
  UseFormReturn,
} from 'react-hook-form'

export type FormProps<TData> = {
  initial?: DefaultValues<TData>
  children: (props: UseFormReturn<TData, any>) => React.ReactNode
  onSubmit?: (data: TData) => void
  resolver?: Resolver<TData, any>
  mode?: 'onBlur' | 'onChange' | 'onSubmit' | 'onTouched' | undefined
}

function Form<TData>({
  initial,
  onSubmit,
  children,
  resolver,
  mode,
}: FormProps<TData>) {
  const renderProps = useForm<TData>({
    defaultValues: initial,
    resolver: resolver,
    mode: mode,
  })

  return (
    <form onSubmit={renderProps.handleSubmit(onSubmit)}>
      {children(renderProps)}
    </form>
  )
}

Form.displayName = 'Form'

export default Form
